import { h } from 'preact';
import { useDonationStep, DonationStepEnum } from '../../hooks/step';
import { useUser } from '../../hooks/user';

/**
 * User details box.
 */
const UserDetails = () => {
	const { user } = useUser();
	const { dispatch } = useDonationStep();

	return (
		<div className="ea-confirm-details">
			<h3 className="ea-confirm-details__title">Summary of Payment Details</h3>
			<div className="ea-confirm-details__row">
				<div className="ea-confirm-details-section">
					<h4 className="ea-confirm-details-section__title">
						Personal Information
					</h4>
					{(user.FirstName && user.LastName) && (
						<p>
							{user.FirstName}
							{' '}
							{user.LastName}
						</p>
					)}
					{user.EmailAddress && (
						<p>{user.EmailAddress}</p>
					)}
					{((user.Occupation && user.Employer) && (
						<p>
							{user.Occupation}
							,
							{' '}
							{user.Employer}
						</p>
					))}
				</div>
				<div className="ea-confirm-details-section ea-confirm-details-section--payment">
					<h4 className="ea-confirm-details-section__title">
						Payment Information
					</h4>
					<div>
						{user.cardType && user.last4 && (
							<p>
								{user.cardType.toUpperCase()}
								{' '}
								{`**** **** **** ${user.last4}`}
							</p>
						)}
						{user.AddressLine1 && (
							<p>
								{user.AddressLine1}
								{user.AddressLine2 && `, ${user.AddressLine2}`}
							</p>
						)}
						{(user.City && user.StateProvince && user.PostalCode) && (
							<p>
								{user.City}
								,
								{' '}
								{user.StateProvince}
								{' '}
								{user.PostalCode}
							</p>
						)}
					</div>
				</div>
			</div>
			<div className="ea-confirm-details__edit">
				<button
					className="ea-btn-reset ea-btn-reset--linklike"
					type="button"
					onClick={() => {
						dispatch({
							type: 'MANUAL_STEP',
							payload: { step: DonationStepEnum.CHECKOUT },
						});
					}}
				>
					<span>Edit</span>
				</button>
			</div>
		</div>
	);
};

export default UserDetails;
